import { Navigate, Route, Routes } from 'react-router-dom';
import { Keyed } from '../../shared/components/Common';
import BusSearch from './BusSearch';
import BusList from './BusList';
import BusSeats from './BusSeats';
import BusReview from './BusReview';
import BusConfirmation from './BusConfirmation';
import BusBookings from './BusBookings';
import BusBookingDetails from './BusBookingDetails';

// Mounted at /bus/*
export default function BusRoutes() {
  return (
    <Routes>
      <Route index element={<BusSearch />} />
      <Route path="results" element={<Keyed page={BusList} />} />
      <Route path="seats" element={<Keyed page={BusSeats} />} />
      <Route path="review" element={<BusReview />} />
      <Route path="confirmation/:bookingId" element={<BusConfirmation />} />
      <Route path="bookings" element={<BusBookings />} />
      <Route path="bookings/:bookingId" element={<BusBookingDetails />} />
      <Route path="*" element={<Navigate to="/bus" replace />} />
    </Routes>
  );
}
